import { BasicColumnTypes } from '@opengov/ogql-types';
import { EOgqlInfixColumnOperators } from '@opengov/reporting-types';

import { columnOperatorAndCalculables, columnOutputTypes } from './types';

// determines the relationship between the "types" (aka BasicColumnTypes) of columns
// and an arithmatic operator (aka EOgqlInfixColumnOperators)
export const determineOutputTypeFromTypesAndOperand = (
  typeA: BasicColumnTypes,
  typeB: BasicColumnTypes,
  operand: EOgqlInfixColumnOperators
) => {
  switch (typeA) {
    case BasicColumnTypes.Numeric:
      return columnOutputTypes[typeA][typeB];
    case BasicColumnTypes.Percent:
      return columnOutputTypes[typeA][typeB];

    case BasicColumnTypes.Year:
      if (operand === EOgqlInfixColumnOperators.subtract && typeB === BasicColumnTypes.Year) {
        return BasicColumnTypes.YearInterval;
      }
      return BasicColumnTypes.Year;

    case BasicColumnTypes.Date:
      if (operand === EOgqlInfixColumnOperators.subtract && typeB === BasicColumnTypes.Date) {
        return BasicColumnTypes.DayInterval;
      }
      return BasicColumnTypes.Date;

    case BasicColumnTypes.DayInterval:
      if (typeA === typeB) return BasicColumnTypes.DayInterval;
      if (
        typeB === BasicColumnTypes.Date &&
        (operand === EOgqlInfixColumnOperators.subtract || operand === EOgqlInfixColumnOperators.add)
      ) {
        return BasicColumnTypes.Numeric;
      }
      return BasicColumnTypes.DayInterval;

    case BasicColumnTypes.YearInterval:
      if (typeA === typeB) return BasicColumnTypes.YearInterval;
      if (
        typeB === BasicColumnTypes.Date &&
        (operand === EOgqlInfixColumnOperators.subtract || operand === EOgqlInfixColumnOperators.add)
      ) {
        return BasicColumnTypes.Numeric;
      }
      return BasicColumnTypes.YearInterval;

    default:
      return columnOutputTypes[typeA];
  }
};

export const getCalculablesForLeftColumnAndOperator = (
  leftColumnType = BasicColumnTypes.Numeric,
  operator = EOgqlInfixColumnOperators.add
) => {
  const columnType = leftColumnType === BasicColumnTypes.Year ? BasicColumnTypes.Date : leftColumnType;
  const operatorToUse = operator ? operator : EOgqlInfixColumnOperators.add;
  return columnOperatorAndCalculables[columnType] && columnOperatorAndCalculables[columnType][operatorToUse]
    ? columnOperatorAndCalculables[columnType][operatorToUse].types
    : columnOperatorAndCalculables[BasicColumnTypes.Numeric][EOgqlInfixColumnOperators.add].types;
};

export const getCustomCalculablesForLeftColumnAndOperator = (
  leftColumnType = BasicColumnTypes.Numeric,
  operator = EOgqlInfixColumnOperators.add
) => {
  let columnType = leftColumnType || BasicColumnTypes.Numeric;
  columnType = leftColumnType === BasicColumnTypes.Year ? BasicColumnTypes.Date : leftColumnType;
  const operatorToUse = operator ? operator : EOgqlInfixColumnOperators.add;
  return columnOperatorAndCalculables[columnType] && columnOperatorAndCalculables[columnType][operatorToUse]
    ? columnOperatorAndCalculables[columnType][operatorToUse].custom
    : columnOperatorAndCalculables[BasicColumnTypes.Numeric][EOgqlInfixColumnOperators.add].custom;
};
